export default __webpack_public_path__ + "static/niche@2x-bfb4a5b61ae72c7bb7ecd70bf60d8f54.png";